/* eslint-disable */
const xm = {
  getItem(key) {
    return JSON.parse(window.localStorage.getItem(key));
  },
  setItem(key, value) {
    return window.localStorage.setItem(key, JSON.stringify(value));
  },
  removeItem(key) {
    return window.localStorage.removeItem(key);
  },
  getToken() {
    return JSON.parse(window.localStorage.getItem('dxzPhone'));
  },
  //判断是移动端还是pc端
  _isMobile() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  },
  isIos() {
    let ua = navigator.userAgent;
    return /iphone|ipad|ipod/ig.test(ua);
  },
  isPhone() {
    let ua = navigator.userAgent;
    return /iphone|ipad|ipod|android/ig.test(ua);
  },
  //判断是安卓还是ios
  appSource() {
    let u = navigator.userAgent;
    // let app = navigator.appVersion;
    //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      console.log("ios");
      return "ios"
    } else {
      console.log("andriod");
      return "andriod"
    }
  },
  // 获取url上信息
  getUrlData() {
    let data = window.location.hash ?
      window.location.hash.slice(1).split('&') :
      window.location.search.slice(1).split('&');
    let obj = {};
    // 出现单个情况
    if (data.length < 2) {
      let objItem = data[0].split('=');
      if (objItem.length < 2) {
        return objItem[0];
      }
      else {
        obj[objItem[0]] = objItem[1];
        return obj;
      }
    }
    else {
      for (let i in data) {
        let objItem = data[i].split('=');
        obj[objItem[0]] = objItem[1];
      }
      return obj;
    }
  },
  getQueryString(name) {
    var objectParams = {}
    let url = decodeURI(window.location.search || window.location.hash)
    let strs
    if (url.indexOf("?") != -1){
      // hash模式进此判断
      if(window.location.hash) {
        strs = url.split("?")[1].toString().split("&")
      // history模式
      }else{
        strs = url.substr(1).split("&")
      }
      // 循环遍历并添加到对象中
      for (let i = 0; i < strs.length; i++) {
        objectParams[strs[i].split("=")[0]] = strs[i].split("=")[1]
      }
    }
    // 判断objectParams对象的长度，大于1则有值
    if(Object.keys(objectParams).length > 0){
      return objectParams[name]
    }
    return ""
  },
  getChannel(self) {
    return self.$route.params.channel || ''
  },
  getInviteCode(self) {
    return self.$route.params.invitecode || ''
  },
  // 绑定事件
  addHandle(element, type, handle, options = false) {
    if (element.addEventListener) {
      element.addEventListener(type, handle, options);
    } else if (element.attachEvent) {
      element.attachEvent("on" + type, handle);
    }
    else {
      element["on" + type] = null
    }
  },
  removeHandle(element, type, handle) {
    element.removeEventListener(type, handle)
  },
  // 阻止默认事件
  preventDefault(event) {
    if (event.preventDefault) {
      event.preventDefault()
    } else {
      event.returnValue = false;
    }
  },
  isJson(obj) {
    let isjson = typeof (obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
    return isjson;
  }
}

export default xm